import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-end",
  "use": "icon-end-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-end\"><defs><style type=\"text/css\"></style></defs><path d=\"M676.864 640.3072c-0.0512 17.8688-14.5408 32.256-32.3584 32.3584H372.8896a32.3072 32.3072 0 0 1-32.3584-32.3584v-263.168c0-17.8176 14.4896-32.256 32.3584-32.256h271.616c17.8176 0 32.3072 14.4896 32.3072 32.256v263.168z\" p-id=\"10452\" /><path d=\"M1017.088 508.8768A507.5456 507.5456 0 0 0 510.5664 0.256H508.416A506.88 506.88 0 0 0 148.992 148.992 506.8288 506.8288 0 0 0 0.2048 508.8768 505.1392 505.1392 0 0 0 148.48 869.0688a504.576 504.576 0 0 0 359.936 148.1728c280.064-2.9184 508.672-228.5056 508.672-508.416z m-957.184 0a448.5632 448.5632 0 0 1 448.4096-448.8704h0.256c249.344 0 451.6352 202.0864 451.6352 448.8704 0 246.4256-202.24 448.7168-451.584 448.7168A446.6688 446.6688 0 0 1 59.904 513.024l-0.0512-4.096z\" p-id=\"10453\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/end.svg
// module id = hqr5
// module chunks = 0